module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_09.3d33e8af.jpg";